import { CaretakerApiService } from "./CaretakerAPIService";

export default {
    requestACallback(payload) {
        return CaretakerApiService.post("/api/website/leads/request-a-callback", payload);
    }
}